module.exports = __webpack_public_path__ + "img/yangan.5f6f09a7.png";